import styled from "@emotion/styled";

import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { isOpen?: boolean, height: number, width: number }) => ({
  transform: props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.4s',
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type DropdownDownIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
  isOpen?: boolean,
}>;

export const DropdownDownIcon: React.FC<DropdownDownIconProps> = ({ width = 12, height = 12, color = colors.primary, isOpen, ...props }) => (
  <IconSpan {...props} isOpen={isOpen} height={height} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 12" fill="none">
      <path d="M9.5 4L6 8L2.5 4H9.5Z" fill={color} />
    </svg>
  </IconSpan>
);


